import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../../components/Modal';
import BannerSettingsPresenter from '../../../../presenters/BannerSettingsPresenter';
import { initialValues } from '../../../../forms/bannerSettingForm';

import EditSettingForm from './components/EditSettingForm';

const EditSettingModal = (props) => {
  const {
    onEditDialogClose,
    isEditDialogOpen,
    onUpdate,
    currentBannerSetting,
    errors,
  } = props;

  const handleSubmit = (params) => {
    return onUpdate(BannerSettingsPresenter.id(currentBannerSetting), params);
  };

  return (
    <Modal
      title="Edit Banner Setting"
      onClose={onEditDialogClose}
      onSave={handleSubmit}
      isModalOpen={isEditDialogOpen}
    >
      <EditSettingForm
        onSubmit={handleSubmit}
        initialValues={initialValues(currentBannerSetting)}
        onModalClose={onEditDialogClose}
        apiErrors={errors}
      />
    </Modal>
  );
};

export default EditSettingModal;

EditSettingModal.propTypes = {
  onEditDialogClose: PropTypes.func.isRequired,
  isEditDialogOpen: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func.isRequired,
  errors: PropTypes.PropTypes.shape(),
  currentBannerSetting: BannerSettingsPresenter.shape().isRequired,
};

EditSettingModal.defaultProps = {
  errors: {},
};
